import { useFormik } from 'formik';
import { useSelector } from 'react-redux';
import { DEMAND_TYPE } from '@demandproai/shared';
import { useTemplateContext } from '../context/TemplateContext';

const useDemandTypeNameForm = () => {
    const { templateListData, addDemandMapText } = useTemplateContext();
    const { demandNameMap } = useSelector((s) => s.demandMap);

    const buildInitialValues = () =>
        templateListData?.reduce((acc, item) => {
            const demand = DEMAND_TYPE[item?.demandType];
            if (!demand) return acc;
            const key = `${item.state}__${item.caseType}__${demand.value}`;
            return { ...acc, [key]: demandNameMap?.[key] || '' };
        }, {}) ?? {};

    const formik = useFormik({
        initialValues: { demandNameMap: buildInitialValues() },
        enableReinitialize: true,
        onSubmit: () => { },
    });

    const handleDemandBlur = ({ item, demand }) => (e) => {
        const value = e.target.value.trim();
        const key = `${item.state}__${item.caseType}__${demand.value}`;
        if (value === (demandNameMap?.[key] || '')) return;
        addDemandMapText({ state: item.state, caseType: item.caseType, value: demand.value, text: value });
    };

    return { formik, handleDemandBlur };
};

export default useDemandTypeNameForm;
